(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["firework-embed"] && !Shopify.designMode) return;
  try {
    
  /* This function is required for the floating player and floating button.
  Shopify's page-builder places these DOM nodes in a weird way that blocks
  the static positioning from working properly. Moving the node to be a
  direct child of <body> makes it work properly. */

  var element = document.getElementById('move-to-body');
  if (element) {
    document.querySelector('body').appendChild(element);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-stack-pdp"] && !Shopify.designMode) return;
  try {
    
 
    $(".tab_content").hide();
    $(".tab_content:first").show();

  
    $("ul.tabs li").click(function() {
		
      $(".tab_content").hide();
      var activeTab = $(this).attr("rel"); 
      $("#"+activeTab).fadeIn();		
		
      $("ul.tabs li").removeClass("active");
      $(this).addClass("active");

	  $(".tab_drawer_heading").removeClass("d_active");
	  $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
	  
    });
	


	$(".tab_drawer_heading").click(function() {
      
      $(".tab_content").hide();
      var d_activeTab = $(this).attr("rel"); 
      $("#"+d_activeTab).fadeIn();
	  
	  $(".tab_drawer_heading").removeClass("d_active");
      $(this).addClass("d_active");
	  
	  $("ul.tabs li").removeClass("active");
	  $("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
    });
	
	
	
	$('ul.tabs li').last().addClass("tab_last");
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack-custom"] && !Shopify.designMode) return;
  try {
    
$(".scustom").slick({
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  responsive: [
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
	{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack-testimonials"] && !Shopify.designMode) return;
  try {
    
$(".regular").slick({
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:false
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-select-faq"] && !Shopify.designMode) return;
  try {
    
$(function() {
  var Accordion = function(el, multiple) {
  this.el = el || {};
  this.multiple = multiple || false;

  // Variables privadas
  var links = this.el.find('.flink');
  // Evento
  links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
  var $el = e.data.el;
  $this = $(this),
  $next = $this.next();

  $next.slideToggle();
  $this.parent().toggleClass('open');

  if (!e.data.multiple) {
  $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
  };
  }	

  var accordion = new Accordion($('.accordion'), false);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-select-slider"] && !Shopify.designMode) return;
  try {
    
$(".regular").slick({
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:'<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0866/7664/files/arrow.png?v=1656333194"/></button>',
  nextArrow:'<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0866/7664/files/arrow.png?v=1656333194"/></button>',
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xt-protein-raise"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
  
    // Variables privadas
    var links = this.el.find('.flink');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }
  
    Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
    $next = $this.next();
  
    $next.slideToggle();
    $this.parent().toggleClass('open');
  
    if (!e.data.multiple) {
    $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
    };
    }	
  
    var accordion = new Accordion($('.accordion'), false);
  });

  } catch(e) { console.error(e); }
})();
})();
